import * as React from "react"

import { cn } from "@/lib/utils"

/*
  Avatar — a person's initials on a colour that stays the same for the same name everywhere.

    <Avatar name="Mohammed Salah" size={22} />      → "MS"

  initials('Mohammed Salah') → 'MS', initials('') → '?'; avatarColor(name) → one of six brand-safe colours.
  Decorative (aria-hidden): always show the name as text next to it.
*/
export function initials(name) {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean)
  if (!parts.length) return "?"
  return ((parts[0][0] || "") + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase()
}

const AVATAR_COLORS = ["#3d3da3", "#0f766e", "#b45309", "#be185d", "#4d7c0f", "#6d28d9"]

export function avatarColor(name) {
  const text = String(name || "")
  let hash = 0
  for (let index = 0; index < text.length; index += 1) hash = ((hash * 31) + text.charCodeAt(index)) >>> 0
  return AVATAR_COLORS[hash % AVATAR_COLORS.length]
}

export function Avatar({ name, size = 22, className }) {
  return (
    <span
      className={cn("inline-grid shrink-0 place-items-center rounded-full font-bold leading-none text-white", className)}
      style={{ width: size, height: size, fontSize: Math.max(9, Math.round(size * 0.42)), background: avatarColor(name) }}
      aria-hidden="true"
    >
      {initials(name)}
    </span>
  )
}
